/**
 * @author David Oravec<xorave06@stud.fit.vutbr.cz>
 */
import dotenv from "dotenv"
import './App.css';
import axios from "axios";
import LoginRoute from "./pages/auth/LoginRoute";
import RegisterRoute from "./pages/auth/RegisterRoute";
import UsersRoute from "./pages/admin/UsersRoute";
import { Routes, Route } from "react-router-dom";
import Auctions from "./pages/auctions/Auctions";
import AuctionForm from "./pages/auctionForm/AuctionForm";
import Header from "./components/Header";
import {ProvideAuth} from "./data/userContext";
import MyAuctions from "./pages/myAuctions/MyAuctions";
import RequireAuth from "./components/RequireAuth";
import {isAdministrator, isLicitator} from "./data/roles";
import ProfileRoute from "./pages/profile/ProfileRoute";
import AuctionsToConfirm from "./pages/auctionsToConfirm/AuctionsToConfirm";
import AuctionDetail from "./pages/auctionDetail/AuctionDetail";
import UserRegisterConfirm from "./pages/userRegisterConfirm/UserRegisterConfirm";
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
dotenv.config()

function App() {
  return (
    <div>
        <ProvideAuth>
        <Header/>
        <Routes>
            <Route path="/" element={<Auctions />} />
            <Route path="/auctions/:id" element={<AuctionDetail />} />
            <Route path="/new-auction" element={<RequireAuth><AuctionForm /></RequireAuth>} />
            <Route path="/admin/users" element={<RequireAuth check={isAdministrator}><UsersRoute /></RequireAuth>} />
            <Route path="/my-auctions" element={<RequireAuth><MyAuctions /></RequireAuth>} />
            <Route path="/profile" element={<RequireAuth><ProfileRoute /></RequireAuth>} />
            <Route path="/auctions-to-confirm" element={<RequireAuth check={isLicitator}><AuctionsToConfirm /></RequireAuth>} />
            <Route path="/users-to-confirm" element={<RequireAuth check={isLicitator}><UserRegisterConfirm /></RequireAuth>} />
            <Route path="login" element={<LoginRoute/>} />
            <Route path="register" element={<RegisterRoute/>} />
        </Routes>
        </ProvideAuth>
    </div>
  );
}

export default App;
